const LoadingField = ({ text = "Loading..." }) => (
    <div className="flex items-center gap-3 p-3 mt-3 rounded-lg border bg-blue-50 border-blue-200">
        <div className="w-5 h-5 border-2 border-blue-500 border-t-transparent rounded-full animate-spin"></div>

        <div>
            <p className="text-sm font-medium text-blue-700">
                {text}
            </p>

            <p className="text-xs text-blue-500">
                Mohon tunggu sebentar...
            </p>
        </div>
    </div>
);

export default LoadingField;